import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

export interface InvitationLookupResult {
  email: string;
  org_name: string;
  role: string;
  expires_at: string;
}

interface ErrorBody {
  error?: string;
  message?: string;
}

export interface InvitationLookupError extends Error {
  status?: number;
  body?: ErrorBody;
}

export function useInvitationLookup(token: string) {
  const api = useApi();
  return useQuery<InvitationLookupResult, InvitationLookupError>({
    queryKey: ['invitation', token],
    enabled: !!token,
    retry: false,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const { data, error, response } = await api.GET('/auth/invitations/{token}', {
        params: { path: { token } },
      });
      if (error) {
        const err = new Error('invitation_lookup_failed') as InvitationLookupError;
        err.status = response?.status;
        err.body = error as ErrorBody;
        throw err;
      }
      return data!;
    },
  });
}
